// Mock data for Aloha Cancer Project

export const organizationInfo = {
  name: "Aloha Cancer Project",
  logo: "https://customer-assets.emergentagent.com/job_f0b80ca3-cf4a-4579-a85b-d33f502f47d6/artifacts/r68ujry0_ACP-Logo%20JPEG.jpg",
  mission: "Empowering and supporting individuals affected by cancer in Hawaii through comprehensive education, resources, and community.",
  vision: "To be Hawaii's most trusted resource for cancer patients, caregivers, and their families, fostering hope and healing through the spirit of Aloha.",
  email: "info@alohacancerproject.org",
  phone: "808-301-2134",
  address: "Honolulu, Hawaii",
  socialLinks: {
    facebook: "https://facebook.com/alohacancerproject",
    instagram: "https://instagram.com/alohacancerproject",
    twitter: "https://twitter.com/alohacancerproject"
  }
};

export const heroContent = {
  title: "Supporting Hawaii's Cancer Community",
  subtitle: "With the Spirit of Aloha",
  description: "Providing resources, education, and support for those fighting cancer and their caregivers across the Hawaiian Islands.",
  backgroundImage: "https://images.unsplash.com/photo-1559494007-9f5847c49d94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxIYXdhaWklMjBzdW5zZXR8ZW58MHx8fHwxNzY5MTQ4ODExfDA&ixlib=rb-4.1.0&q=85",
  ctaPrimary: "Get Support",
  ctaSecondary: "Donate Now"
};

export const impactStats = [
  { number: "15+", label: "Community Events" },
  { number: "100+", label: "Volunteers" }
];

export const programs = [
  {
    id: 1,
    title: "Education",
    description: "Empowering patients, caregivers, and the community with knowledge about traditional, integrative, and alternative cancer care options.",
    icon: "BookOpen",
    audiences: ["Patients", "Caregivers", "Traditional medicine practitioners", "General public"],
    methods: ["Educational events", "Website resources", "Media coverage", "Community outreach"],
    partners: ["Doctors", "Health coaches", "Counselors", "Nutritionists", "Natural & local food vendors"]
  },
  {
    id: 2,
    title: "Public Information & Data",
    description: "Connecting Hawaii's cancer community with trusted information and the practitioners — both traditional and integrative — who can help.",
    icon: "Database",
    audiences: ["Patients", "Caregivers", "Traditional & integrative practitioners"],
    methods: ["Website hub", "Curated resources", "Community events", "Professional partnerships"],
    partners: ["Doctors", "Health coaches", "Local food vendors", "Healthcare specialists"]
  },
  {
    id: 3,
    title: "Fundraising",
    description: "Powering our mission and the Alternative Treatment Scholarship Fund through annual group events, corporate sponsorships, and community giving.",
    icon: "Gift",
    audiences: ["Patients in need", "Sponsoring partners", "Donors", "Corporate sponsors"],
    methods: ["Annual fundraising event", "Online giving", "Sponsorships", "Community visibility"],
    partners: ["Corporate sponsors", "Local businesses", "Event promoters", "Medical professionals"]
  },
  {
    id: 4,
    title: "Inspiration & Community",
    description: "Building an ohana where patients, caregivers, and survivors can lean on each other, share their stories, and find hope.",
    icon: "Heart",
    audiences: ["Patients", "Caregivers", "Survivors", "Hawaii's cancer community"],
    methods: ["Community events", "Storytelling", "Professional networking", "Partnerships with like-minded organizations"],
    partners: ["Other cancer organizations", "Medical professionals", "Local companies", "Donors"]
  },
  {
    id: 5,
    title: "Advocacy",
    description: "Fighting for better cancer care policy, broader treatment access, and stronger support systems for patients across Hawaii.",
    icon: "Megaphone",
    audiences: ["Patients", "Caregivers", "Integrative practitioners", "Government officials"],
    methods: ["Policy advocacy", "Lobbying", "Community campaigns", "Media coverage"],
    partners: ["Health/policy change advocates", "Lobbyists", "Government officials", "Other cancer organizations"]
  }
];

export const resources = [
  {
    id: 1,
    title: "For Patients",
    description: "Find support, treatment information, and community resources to help you on your cancer journey.",
    items: [
      "Treatment options guide",
      "Financial assistance programs",
      "Support group schedules",
      "Nutrition and wellness tips",
      "Mental health resources"
    ],
    icon: "User"
  },
  {
    id: 2,
    title: "For Caregivers",
    description: "Resources and support for the dedicated individuals caring for their loved ones.",
    items: [
      "Caregiver support groups",
      "Self-care resources",
      "Respite care information",
      "Communication guides",
      "Burnout prevention tips"
    ],
    icon: "HandHeart"
  },
  {
    id: 3,
    title: "Healthcare Partners",
    description: "Connect with our network of trusted healthcare professionals and practitioners.",
    items: [
      "Oncologists",
      "Nutritionists",
      "Mental health counselors",
      "Alternative medicine practitioners",
      "Health coaches"
    ],
    icon: "Stethoscope"
  }
];

export const upcomingEvents = [
  {
    id: 1,
    title: "1st Annual ALOHA TEQUILA & ARTS Festival",
    date: "Saturday, June 20th, 2026",
    time: "5:00 PM - 9:00 PM",
    location: "International Market Place, Waikiki",
    description: "Hawaiʻi's premier curated agave festival. Sample 80+ curated tequila brands, enjoy Mexican-inspired food vendors, live DJs & entertainment, arts & culture, and an exclusive VIP experience with 3rd floor access. A multi-level tasting experience connecting brands directly to consumers — limited to 1,000 guests. Sip. Support. Celebrate.",
    image: "https://customer-assets.emergentagent.com/job_6ed424f7-dd20-4020-85d3-049c99db07b8/artifacts/51ta6jfm_5x7%20ATF%20Flyer.png",
    link: "https://alohacancer.ticketspice.com/aloha-tequila-arts-festival",
    qrCode: "https://customer-assets.emergentagent.com/job_6ed424f7-dd20-4020-85d3-049c99db07b8/artifacts/bjm6vmbe_barcode_https___alohacancer.ticketspice.com_aloha-tequila-arts-festival.png",
    type: "Fundraiser"
  }
];

export const getInvolvedOptions = [
  {
    id: 1,
    title: "Volunteer",
    description: "Join our ohana of dedicated volunteers who help at events, provide support, and make a difference in our community.",
    icon: "HandHelping",
    cta: "Become a Volunteer"
  },
  {
    id: 2,
    title: "Donate",
    description: "Your generous donations help us provide resources, support families, and fund our programs throughout Hawaii.",
    icon: "Gift",
    cta: "Make a Donation"
  },
  {
    id: 3,
    title: "Partner",
    description: "Healthcare providers, businesses, and organizations can partner with us to expand our reach and impact.",
    icon: "Handshake",
    cta: "Become a Partner"
  },
  {
    id: 4,
    title: "Sponsor",
    description: "Corporate sponsors help fund our events and programs while gaining visibility in the community.",
    icon: "Building",
    cta: "Sponsor an Event"
  }
];

export const founders = [
  {
    id: 1,
    names: ["Christa Wittmier", "Daniel Gray"],
    role: "Co-Founders",
    image: "https://customer-assets.emergentagent.com/job_6ed424f7-dd20-4020-85d3-049c99db07b8/artifacts/3mtholbw_Screenshot%202025-06-21%20233117.png"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Mark Becker",
    role: "Leadership Team",
    description: "Dedicated board member guiding the organization's mission and strategic direction."
  },
  {
    id: 2,
    name: "Flash Hansen",
    role: "Leadership Team",
    description: "Dedicated board member guiding the organization's mission and strategic direction."
  },
  {
    id: 3,
    name: "Medical Advisory Board",
    role: "Healthcare Partners",
    description: "Healthcare professionals who ensure our resources and information are accurate and helpful."
  },
  {
    id: 4,
    name: "Volunteer Coordinators",
    role: "Community Leaders",
    description: "Passionate individuals who organize our volunteers and community outreach efforts."
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "The Aloha Cancer Project was there for our family when we needed support the most. Their resources and community made all the difference.",
    author: "Maria K.",
    role: "Cancer Survivor"
  },
  {
    id: 2,
    quote: "As a caregiver, I found the support groups invaluable. Knowing I wasn't alone in this journey gave me strength.",
    author: "David L.",
    role: "Caregiver"
  },
  {
    id: 3,
    quote: "This organization truly embodies the spirit of Aloha. They've helped countless families in Hawaii navigate the challenges of cancer.",
    author: "Dr. Sarah N.",
    role: "Healthcare Partner"
  }
];

export const faqItems = [
  {
    question: "How can I get support from Aloha Cancer Project?",
    answer: "You can reach out to us through our contact form, call our helpline, or attend one of our community events. We offer resources for patients, caregivers, and families affected by cancer."
  },
  {
    question: "Are your services free?",
    answer: "Yes, all of our support services, resources, and educational materials are provided free of charge to cancer patients and their families in Hawaii."
  },
  {
    question: "How can I volunteer?",
    answer: "We welcome volunteers for events, administrative support, and community outreach. Fill out our volunteer form or contact us to learn about current opportunities."
  },
  {
    question: "Where do donations go?",
    answer: "100% of donations go toward supporting cancer patients and families through direct assistance, educational programs, community events, and resource development."
  },
  {
    question: "Do you offer support groups?",
    answer: "Yes, we offer regular support groups for both patients and caregivers. Check our events calendar for upcoming meetings or contact us for more information."
  }
];
